import "react-toastify/dist/ReactToastify.css";
import ProfileForm from "./Profile-Section/Profile-Form";
import ProfileFormPreview from "./Profile-Section/ProfileFormPreview";
import { useState } from "react";

// The Profile component renders a form for the user to edit their profile
// information. It also renders a preview of the user's profile information.
const Profile = () => {
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  return (
    <div className="Profile-section">
      {isFormVisible ? (
        <ProfileForm setIsFormVisible={setIsFormVisible} isUpdating={isUpdating} />
      ) : (
        <ProfileFormPreview setIsFormVisible={setIsFormVisible} setIsUpdating={setIsUpdating} />
      )}
    </div>
  );
};

export default Profile;
